export const disableMapObject = () => {
    return {
        type: 'DISABLE_MAP_OBJECTS'
    }
}

export const enableMapObject = () => {
    return {
        type: 'ENABLE_MAP_OBJECTS'
    }
}